import { EyeOff } from 'lucide-react'
import { RestrictionScreen } from './RestrictionScreen'
import { GEO_STR as S } from './geoApi'

/**
 * A11.08 — Kontent cheklovlari. REAL `/admin/countries` + greenfield overlay
 * (`/admin/geo/content-restrictions` → `{code, content}`): davlat bo'yicha
 * kontent cheklovlari (18+, stiker, media).
 */
export function ContentRestrictionsScreen() {
  return (
    <RestrictionScreen
      screenId="A11.08"
      title={S.contentTitle}
      note={S.contentNote}
      icon={<EyeOff size={28} strokeWidth={1.5} />}
      overlayPath="/admin/geo/content-restrictions"
      overlayKey="restrictions"
      overlayField="content"
      overlayHeader={S.content}
    />
  )
}
